// extracted by mini-css-extract-plugin
export default {"stepperCustomDot":"styles_stepperCustomDot__bH1Xi","activeStepperCustomDot":"styles_activeStepperCustomDot__J3AyT","errorColor":"styles_errorColor__KjG6z"};